<template>
    <div class="container py-4">
        <h2 class="mb-4">Apps</h2>
        <router-link :to="{name: 'appCreate'}" class="btn btn-outline-success btn-sm mb-3">New app</router-link>
        <div class="card">
            <div class="card-body">
                <vue-good-table
                        :columns="columns"
                        :isLoading.sync="isLoading"
                        :pagination-options="{enabled: true}"
                        :rows="table.rows"
                        :sort-options="{
                            enabled: false
                          }"
                        :totalRows="table.totalRecords"
                        @on-column-filter="onColumnFilter"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        mode="remote"
                        styleClass="table table-hover">
                    <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'name'">
                    <router-link :to="{name: 'appUpdate', params: {id: props.row.id}}">{{props.row.name}}</router-link>
                </span>
                        <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
                    </template>
                </vue-good-table>
            </div>
        </div>
    </div>
</template>
<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import {VueGoodTable} from 'vue-good-table'
    import {mapActions, mapGetters} from 'vuex'
    import loaderTable from '@/components/charts/loaders/loader-table.vue'

    export default {
        name: 'modal',
        data() {
            return {
                isLoading: false,
                columns: [
                    {
                        label: 'Name',
                        field: 'name',
                    },
                    {
                        label: 'App id',
                        field: 'app_id',
                    },
                    {
                        label: 'Token',
                        field: 'token',
                    },
                    {
                        label: 'Order',
                        field: 'order',
                    },

                ],
            };
        },
        computed: mapGetters({
                chartModal: 'CHART_MODAL',
                table: 'TABLE'
            }
        ),
        components: {
            VueGoodTable,
            loaderTable
        },
        mounted() {
            this.loadItems()
        },
        methods: {
            ...mapActions({
                    loadItems: 'GET_APPS',
                }
            ),
            updateParams(newProps) {
                this.$store.dispatch('CHANGE_SERVERPARAMS', newProps)
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },
            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },
            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
        }
    }
</script>
<style>
    .vgt-wrap__footer {
        color: #ffffff;
        padding: 0.5em !important;
        border: none !important;
        border-top: 1px solid #dcdfe6 !important;
        background: #ffffff !important;
    }
</style>
